































































import { Component, Prop, Vue } from 'vue-property-decorator';
import VueForm from 'vue-form';

@Component
export default class Jobs extends Vue {
  
}
